import React from 'react';
import { Button } from 'react-magma-dom';
import PropTypes from 'prop-types';

const ImportButton = props => {
  const { onImportClick } = props;

  return (
    <Button onClick={onImportClick}>
      SELECT
    </Button>
  );
};

ImportButton.propTypes = {
  onImportClick: PropTypes.func
};

export default ImportButton;


